(() => {
  const soldOutText = 'Sold Out';
  const blockedVariants = new Set();

  const registerVariantMap = (root = document) => {
    root.querySelectorAll('script[data-forced-oos-variants]').forEach((script) => {
      try {
        const map = JSON.parse(script.textContent || '{}');
        Object.keys(map).forEach((id) => {
          if (map[id]) blockedVariants.add(String(id));
        });
      } catch (error) {
        console.warn('Unable to read forced OOS variant data.', error);
      }
    });
  };

  const isBlockedVariant = (variantId) => blockedVariants.has(String(variantId));

  const variantIdsFromAddBody = (body) => {
    if (!body) return [];

    if (body instanceof FormData || body instanceof URLSearchParams) {
      const ids = [];
      body.forEach((value, key) => {
        if (key === 'id' || key.endsWith('[id]')) ids.push(String(value));
      });
      return ids;
    }

    if (typeof body === 'string') {
      try {
        const json = JSON.parse(body);
        if (json.id) return [String(json.id)];
        if (Array.isArray(json.items)) return json.items.map((item) => String(item.id)).filter(Boolean);
      } catch (_) {
        return variantIdsFromAddBody(new URLSearchParams(body));
      }
    }

    return [];
  };

  const variantIdsFromUpdateBody = (body) => {
    if (!body) return [];

    if (typeof body === 'string') {
      try {
        const json = JSON.parse(body);
        if (!json.updates) return [];

        return Object.entries(json.updates)
          .filter(([, quantity]) => Number(quantity) > 0)
          .map(([id]) => String(id));
      } catch (_) {
        return [];
      }
    }

    if (body instanceof FormData || body instanceof URLSearchParams) {
      const ids = [];
      body.forEach((value, key) => {
        const match = key.match(/^updates\[(\d+)\]$/);
        if (match && Number(value) > 0) ids.push(match[1]);
      });
      return ids;
    }

    return [];
  };

  const isCartAddUrl = (url) => {
    const cartAddUrl = window.routes?.cart_add_url || '/cart/add';
    return String(url || '').includes('/cart/add') || String(url || '').includes(cartAddUrl);
  };

  const isCartUpdateUrl = (url) => {
    const cartUpdateUrl = window.routes?.cart_update_url || '/cart/update';
    return String(url || '').includes('/cart/update') || String(url || '').includes(cartUpdateUrl);
  };

  const blockAttempt = (formOrButton) => {
    const button = formOrButton?.querySelector?.('[name="add"], [type="submit"]') || formOrButton;
    if (!button) return;

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');

    const text = button.querySelector('span') || button;
    text.textContent = soldOutText;
  };

  const refreshProductInfo = () => {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      productInfo.refreshForcedOutOfStockState?.();
    });
  };

  registerVariantMap();

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !isCartAddUrl(form.action)) return;

      const ids = variantIdsFromAddBody(new FormData(form));
      if (ids.some(isBlockedVariant)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        blockAttempt(form);
      }
    },
    true
  );

  const originalFetch = window.fetch;
  window.fetch = function patchedFetch(input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url;
    const ids = isCartAddUrl(url)
      ? variantIdsFromAddBody(init.body)
      : isCartUpdateUrl(url)
        ? variantIdsFromUpdateBody(init.body)
        : [];

    if (ids.some(isBlockedVariant)) {
      return Promise.resolve(
        new Response(
          JSON.stringify({
            status: 422,
            message: soldOutText,
            description: soldOutText,
            errors: soldOutText,
          }),
          { status: 422, headers: { 'Content-Type': 'application/json' } }
        )
      );
    }

    return originalFetch.apply(this, arguments);
  };

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          registerVariantMap(node);
          refreshProductInfo();
        }
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.ForcedOutOfStock = {
    isBlockedVariant,
    soldOutText,
    registerVariantMap,
  };

  refreshProductInfo();
})();
